/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {AuthGuardService} from "../shared/services/auth-guard.service";
import {locaisRoutes} from "./locais/locais-routing.module";
import {BombasComponent} from "./bombas/bombas.component";
import {bombasRoutes, auditoriaRoutes} from "./bombas/bombas-routing.module";
import {abastecimentoBensRoute} from "./abastecimento-bens/shared/data.service";
import {combustiveisRoute} from "./combustiveis/shared/data.service";
import {CombustiveisComponent} from "./combustiveis/combustiveis.component";
import {combustiveisRoutes} from "./combustiveis/combustiveis-routing.module";
import {LocaisComponent} from "./locais/locais.component";
import {bombasRoute, bombasAuditoriaRoute} from "./bombas/shared/data.service";
import {locaisRoute} from "./locais/shared/data.service";
import {AbastecimentoConfiguracaoComponent} from "./configuracao/abastecimento-configuracao.component";
import {abastecimentosRoute} from "./shared/data.service";
import {tanquesRoute} from "./tanques/shared/data.service";
import {TanquesComponent} from "./tanques/tanques.component";
import {tanquesRoutes} from "./tanques/tanques-routing.module";
import {tipoAjustesRoute} from "./tipo-ajustes/shared/data.service";
import {TipoAjustesComponent} from "./tipo-ajustes/tipo-ajustes.component";
import {tipoAjustesRoutes} from "./tipo-ajustes/tipo-ajustes-routing.module";
import {AbastecimentoBensComponent} from "./abastecimento-bens/abastecimento-bens.component";
import {abastecimentoBensRoutes} from "./abastecimento-bens/abastecimento-bens-routing.module";
import {AbastecimentoRelatorioComponent} from "./relatorios/abastecimento-relatorio.component";
import {configuracaoRoute} from "../shared/services/data.service";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class AbastecimentosRoutingModule {}

export const abastecimentosRoutes: any[] = [
    {
        path: '',
        redirectTo: './' + abastecimentosRoute + '/' + abastecimentoBensRoute,
        pathMatch: 'full'
    },{
        path: 'configuracoes',
        component: AbastecimentoConfiguracaoComponent,
        canActivate: [AuthGuardService],
    },{
        path: 'relatorios',
        component: AbastecimentoRelatorioComponent,
        canActivate: [AuthGuardService],
    },{
        path: locaisRoute,
        component: LocaisComponent,
        canActivate: [AuthGuardService],
        children: locaisRoutes
    },{
        path: configuracaoRoute + '/' + bombasRoute,
        component: BombasComponent,
        canActivate: [AuthGuardService],
        children: bombasRoutes
    },{
        path: bombasAuditoriaRoute,
        component: BombasComponent,
        canActivate: [AuthGuardService],
        children: auditoriaRoutes
    },{
        path: abastecimentoBensRoute,
        component: AbastecimentoBensComponent,
        canActivate: [AuthGuardService],
        children: abastecimentoBensRoutes
    },{
        path: combustiveisRoute,
        component: CombustiveisComponent,
        canActivate: [AuthGuardService],
        children: combustiveisRoutes
    },{
        path: tanquesRoute,
        component: TanquesComponent,
        canActivate: [AuthGuardService],
        children: tanquesRoutes
    },{
        path: tipoAjustesRoute,
        component: TipoAjustesComponent,
        canActivate: [AuthGuardService],
        children: tipoAjustesRoutes
    }
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimentos-routing.module.ts
 **/